import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  signupStep: 0,
  signup: {},
};

const mutations = {
  SET_SIGNUP_STEP(state, signupStep) {
    state.signupStep = signupStep;
  },
  SET_SIGNUP(state, signup) {
    state.signup = signup;
  },
};

const actions = {};

const getters = {};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});
